import { Partner } from "@cede/types";

export const getPartnerIdFromOrigin = (origin: string, partners: Partner[]): number | undefined => {
  let host: string;
  try {
    const parsedUrl = new URL(origin);
    host = parsedUrl.host;
  } catch {
    return undefined;
  }

  for (const partner of partners) {
    const regex = new RegExp(partner.host);
    if (partner.host && regex.test(host)) {
      return partner.id;
    }
  }
  return undefined;
};

export const getPartnerIdFromSource = (source: string, partners: Partner[]): number | undefined => {
  return partners.find((partner) => partner.refererSource && partner.refererSource === source)?.id;
};

export const retrievePartnerId = (partners: Partner[], origin?: string, source?: string) => {
  let partnerId: number | undefined;
  if (origin || source) {
    if (source) partnerId = getPartnerIdFromSource(source, partners);
    if (!partnerId && origin) partnerId = getPartnerIdFromOrigin(origin, partners);
  }
  return partnerId;
};
